import { GiftCardSVG } from "@/app/(shop)/giftcard/components/giftCardSVG";
import { Merchant } from "@/dto/merchant";
import { CurrencyCode } from "@/dto/currencyCodes";
import { colorThemes } from "@/utils/giftCardColorThemes";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";
import { useFormatter, useLocale } from "next-intl";

interface GiftCardImageProps {
  merchant: Merchant;
  amount?: number;
  currency?: CurrencyCode;
}

export const GiftCardImage = ({
  merchant,
  amount,
  currency,
}: GiftCardImageProps) => {
  const userLocale = useLocale();
  const formatter = useFormatter();

  const shouldHideImageText = !userLocale.includes("en");

  const value = formatter.number(amount ?? 0, {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
    currencyDisplay: "symbol",
  });

  const merchantColorName =
    merchant.merchantMeta?.colorPalette?.name ?? "Green";

  const { primaryColor, secondaryColor, blendRect1Color, blendRect2Color } =
    colorThemes[merchantColorName] ?? colorThemes["Green"];

  return (
    <div
      data-testid={applyDataTestId(pom.products.giftCardImage)}
      className="relative w-full"
    >
      <GiftCardSVG
        primaryColor={primaryColor}
        secondaryColor={secondaryColor}
        blendRect1Color={blendRect1Color}
        blendRect2Color={blendRect2Color}
        hideText={shouldHideImageText}
      />

      {amount !== undefined && (
        <div className="absolute top-1 right-8 xl:right-10 text-white/80 text-[40px] sm:text-[55px] font-medium">
          {value}
        </div>
      )}
    </div>
  );
};
